import { Footer } from "../../../layouts/footer";
import ResponsiveAppBar from "../../../layouts/navbar";

export const NotificationPage = () => {
  return (
    <>
      <div
        id="wrapper"
        style={{
          fontFamily: "Albert Sans, sans-serif",
          fontSize: "14px",
          lineHeight: "22px",
          fontWeight: 400,
          color: "var(--main)",
          backgroundColor: "var(--white)",
        }}
      >
        <ResponsiveAppBar />
        <h3 className="fs-22 fw-6 text-center mt-5">Notifications</h3>
        <section className="flat-spacing-16 pt-4">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-6">
                <div className="tf-icon-box noti style-border-line mb-3">
                  <p className="small address-text">20 Nov 2024, 12:30 PM</p>
                  <h3 className="fs-16 fw-5 line-n">
                    Thank you for your review! 🎉
                  </h3>
                  <p className="fw-5 address-text">
                    We appreciate your feedback. Your review has been submitted
                    successfully and will help us serve you better.
                  </p>
                  <p className="address-text">
                    🍰 Keep Enjoying our delicious treats!
                  </p>
                </div>
                <div className="tf-icon-box noti style-border-line mb-3">
                  <p className="small address-text">20 Nov 2024, 12:30 PM</p>
                  <h3 className="fs-16 fw-5 line-n">Review Approved! ✅</h3>
                  <p className="fw-5 address-text">
                    Your review is now live. Thanks for sharing your thoughts!
                  </p>
                  <button className="btn-reorder mt-2">
                    View my Reviews <i className="icon icon-arrow-right"></i>
                  </button>
                </div>
                <div className="tf-icon-box noti style-border-line mb-3">
                  <p className="small address-text">20 Nov 2024, 12:30 PM</p>
                  <h3 className="fs-16 fw-5 line-n">Payment Successful! 💳</h3>
                </div>
                <div className="tf-icon-box noti style-border-line mb-3">
                  <p className="small address-text">20 Nov 2024, 12:30 PM</p>
                  <h3 className="fs-16 fw-5 line-n">Payment Failed! ❌</h3>
                </div>
                <div className="tf-icon-box noti style-border-line mb-3">
                  <p className="small address-text">20 Nov 2024, 12:30 PM</p>
                  <h3 className="fs-16 fw-5 line-n">Order Confirmed! 🎉</h3>
                </div>
                <div className="tf-icon-box noti style-border-line mb-3">
                  <p className="small address-text">20 Nov 2024, 12:30 PM</p>
                  <h3 className="fs-16 fw-5 line-n">Order Dispatched! 🚚</h3>
                </div>
                <div className="tf-icon-box noti style-border-line mb-3">
                  <p className="small address-text">20 Nov 2024, 12:30 PM</p>
                  <h3 className="fs-16 fw-5 line-n">Order Delivered! ✅</h3>
                </div>
              </div>
            </div>
          </div>
        </section>
        <Footer />
      </div>
    </>
  );
};
